// tslint:disable:no-string-literal
import { Button, Card, Col, Divider, Modal, notification, Row, Table } from 'antd';
import * as React from 'react';

import SuppliersQuery from '../../components/Query/Suppliers';
import SupplierDetail from './SupplierDetail';
import { Title } from '../../components/Layout/components';

interface ISuppliersTableState {
  supplier?: GQL.ISupplier;
}

interface ISuppliersTableProps { }

export default class SuppliersTable extends React.Component<ISuppliersTableProps, ISuppliersTableState> {

  constructor(props: ISuppliersTableProps) {
    super(props);
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <SuppliersQuery>
            {({ suppliers, deleteSupplier, createSupplier, updateSupplier }: any) => {
              return this.renderData(
                suppliers.suppliers,
                updateSupplier,
                createSupplier,
                deleteSupplier,
                suppliers.refetch
              );
            }}
          </SuppliersQuery>
        </Col>
      </Row>
    );
  }

  private renderData(
    suppliers: any,
    updateSupplier: Function,
    createSupplier: Function,
    deleteSupplier: Function,
    refetch: Function
  ) {
    if (suppliers) {
      return (
        <div>
          <Title>Suppliers</Title>
          <Divider />
          <Button onClick={() => this.newSupplier()}>Create new supplier</Button>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={suppliers}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column title="Name" dataIndex="name" key="name" />
            <Table.Column
              width={300}
              title="Actions"
              dataIndex="actions"
              key="actions"
              render={(u: any, row: any) => this.renderActions(u, row, deleteSupplier, refetch)}
            />
          </Table>
          {this.state &&
            this.state.supplier && (
              <SupplierDetail
                supplier={this.state.supplier}
                onSave={a => this.upsert(a, updateSupplier, createSupplier, refetch)}
                onCancel={() => this.setCurrentSupplier(undefined)}
              />
            )}
          <Divider />
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading suppliers ..." style={{ width: '100%' }} />
      </div>
    );
  }

  private renderActions(u: any, supplier: GQL.ISupplier, deleteSupplier: Function, refetch: Function) {
    return (
      <div>
        <Button type={'dashed'} onClick={() => this.setCurrentSupplier(supplier)}>
          Edit
        </Button>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(supplier, deleteSupplier, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private newSupplier() {
    this.setCurrentSupplier({
      name: '',
      description: '',
      categories: []
    });
  }

  private setCurrentSupplier(supplier: any) {
    this.setState({ supplier });
  }

  private delete(supplier: GQL.ISupplier, deleteSupplier: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete ${supplier.name}?`,
      content: (
        <span>
          Are you sure you want to delete supplier <strong>{supplier.name}</strong>
        </span>
      ),
      onOk: () => {
        return deleteSupplier({
          variables: {
            id: supplier.id
          }
        }).then(() => refetch());
      }
    });
  }

  private upsert(supplier: GQL.ISupplier, updateSupplier: Function, createSupplier: Function, refetch: Function) {
    if (supplier != undefined) {
      const variables = {
        id: supplier.id,
        supplier: { name: supplier.name }
      };

      if (supplier.id) {
        return updateSupplier({ variables })
          .then(() => this.setCurrentSupplier(null))
          .then(() => refetch())
          .then(() =>
            notification['success']({
              message: 'Info',
              description: `Supplier "${variables.supplier.name}" has been updated.`
            })
          );
      }

      createSupplier({ variables })
        .then(() => this.setCurrentSupplier(null))
        .then(() => refetch())
        .then(() =>
          notification['success']({
            message: 'Info',
            description: `Supplier "${variables.supplier.name}" has been created.`
          })
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Suppliers/SuppliersTable.tsx